export default {
  transactionsErp: null,
  transactionsStrongbox: null,
  transactionsBank: null,
  transactionsInstitution: null,
}
